module.exports = __webpack_public_path__ + "kudos_81.svg?886c717c80bd445d695796c3be17b364";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kudos/kudos_81.svg
// module id = 185
// module chunks = 0